"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _MattermostPlugin = /*#__PURE__*/ _interop_require_default(require("./MattermostPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _MattermostPlugin.default,
    id: 'mattermost',
    title: 'Mattermost',
    version: '0.0.1',
    logo: 'plugins/mattermost.png',
    description: 'Mattermost brings all your team communication into one place, making it searchable and accessible anywhere.',
    price: 'Free',
    tags: 'Chat',
    category: 'Chat',
    inputs: {
        title: 'Configure Mattermost',
        array: true,
        items: [
            {
                key: 'channel',
                label: 'Channel Name',
                placeholder: 'Channel Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'webhook_url',
                label: 'Webhook URL',
                placeholder: 'Webhook URL',
                type: _nocodbsdk.XcType.Password,
                required: true
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully installed and Mattermost is enabled for notification.',
        msgOnUninstall: ''
    }
};
const _default = config;
